import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5661%3A7220
 *
 * @param {SvgIconProps} props - svg props
 */
export const DeleteButtonIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z' fill={color}/>
            <path fillRule='evenodd' clipRule='evenodd' d='M9.06712 6.80547V8.22214H9.54712V7.42125C9.54712 7.29092 9.67619 7.18514 9.83512 7.18514H14.1626C14.3221 7.18514 14.4511 7.29092 14.4511 7.42125V8.22214H14.9338V6.80547C14.9338 6.54481 14.6757 6.33325 14.3567 6.33325H9.64419C9.32526 6.33325 9.06712 6.54481 9.06712 6.80547ZM17.3332 8.45844C17.3332 8.3281 17.2137 8.22233 17.0665 8.22233H6.93317C6.78597 8.22233 6.6665 8.3281 6.6665 8.45844V8.93066C6.6665 9.06099 6.78597 9.16677 6.93317 9.16677H7.73317L8.7721 17.2205C8.78757 17.4708 9.0217 17.6668 9.30437 17.6668H14.6953C14.9785 17.6668 15.2116 17.4708 15.2276 17.2205L16.2665 9.16677H17.0665C17.2137 9.16677 17.3332 9.06099 17.3332 8.93066V8.45844Z' fill='white'/>
        </SvgIcon>
    )
}

export default DeleteButtonIcon
